import RegularProduct from 'components/ProductPage/Type/RegularProduct/RegularProduct';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showHighlightLayerWithPDP } from 'viewModel/selectors/testTarget/showHighlightLayerWithPDP';
import { isShowSMNEnabledSelector } from 'viewModel/selectors/testTarget/showSMNSelector';
import { featuresAIBeautyChatSelector } from 'ai/selectors/testTarget/featuresAIBeautyChatSelector';
import { showCollapseInfoSectionSelector } from 'viewModel/selectors/testTarget/showCollapseInfoSectionSelector';
import { showAddDropDownReviewSectionSelector } from 'viewModel/selectors/testTarget/showAddDropDownReviewSectionSelector';

const fields = createStructuredSelector({
    highlightLayerWithPDP: showHighlightLayerWithPDP,
    featuresAIBeautyChat: featuresAIBeautyChatSelector,
    showSMNEnabled: isShowSMNEnabledSelector,
    showCollapseInfoSection: showCollapseInfoSectionSelector,
    showAddDropDownReviewSection: showAddDropDownReviewSectionSelector
});

const withHighlightValueVisibilityProps = connect(fields);

export default withHighlightValueVisibilityProps(RegularProduct);
